import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { recordTypes } from "../../../../API/config";
import styles from "./styles";
import { AttributeGroup, NoAccessScreen } from "../../../../Component";
import EntityLinks from "../../../EntityLinks";

const KYC = (props) => {
  const {
    classes,
    entity,
    onDocumentUpdate,
    hasRecordPermission,
    handleOnChange,
    handleOnUnitChange,
    listOptions,
    kycAttributes,
  } = props;
  const { confidential } = entity || {};

  const [canViewKycFields, setCanViewKycFields] = useState();
  const [canViewLinks, setCanViewLinks] = useState();
  const [canViewSensitiveFields, setCanViewSensitiveFields] = useState();
  const [maskSensitive, setMaskSensitive] = useState(false);
  const [isLoaded, setLoaded] = useState(false);

  useEffect(() => {
    const setPermissions = async () => {
      const { permissions = {} } = entity;
      const canViewKycFields = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewKycFields.name
      );
      setCanViewKycFields(canViewKycFields);
      const canViewLinks = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewKycLinks.name
      );
      setCanViewLinks(canViewLinks);
      const canViewSensitiveFields = hasRecordPermission(
        permissions,
        recordTypes.record.actions.viewSensitiveFields.name
      );
      setCanViewSensitiveFields(canViewSensitiveFields);

      if (confidential && !canViewSensitiveFields) {
        setMaskSensitive(true);
      }
      setLoaded(true);
    };
    setPermissions();
  }, [entity]);

  if (isLoaded && !canViewKycFields) {
    return <NoAccessScreen />;
  }

  const handleChange = (attrId, newValue) => {
    handleOnChange(attrId, newValue);
  };

  const handleUnitChange = (attrId, newUnitValue) => {
    handleOnUnitChange(attrId, newUnitValue);
  };

  const renderAttributes = () => {
    const subSectionElements = [];
    for (let sc in kycAttributes) {
      subSectionElements.push(
        <div key={sc} className={classes.inputContainerStyle}>
          <AttributeGroup
            attributes={kycAttributes[sc]}
            maskSensitive={maskSensitive}
            onChange={handleChange}
            onUnitChange={handleUnitChange}
            listOptions={listOptions}
          />
        </div>
      );
    }

    return subSectionElements;
  };

  return (
    <div className={classes.pageContent}>
      {renderAttributes()}
      {(!confidential || canViewSensitiveFields) && canViewLinks && (
        <EntityLinks
          entity={entity}
          type="KYC"
          onDocumentUpdate={onDocumentUpdate}
          hasRecordPermission={hasRecordPermission}
        />
      )}
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(KYC);
